module.exports = __webpack_public_path__ + "img/sony-75class-tv.2f90b9bb.jpg";